import React, { forwardRef } from 'react';
import { VerticalStackLayout } from './vertical-stack-layout/vertical-stack-layout';
import { HorizontalStackLayout } from './horizontal-stack-layout/horizontal-stack-layout';
import type {
  GDSStackLayoutProps,
  GDSVerticalStackLayoutProps,
  GDSHorizontalStackLayoutProps,
} from './stack-layout.types';
import type { GDSOrientationValues } from '../../types';
import { useResponsiveProp } from '../../hooks/use-responsive-prop';
import { GenesisCoreInspector } from '../../test-utils/genesis-core-inspector';

const DISPLAY_NAME = 'StackLayout';

export const StackLayout = forwardRef<HTMLDivElement, GDSStackLayoutProps>(
  (
    {
      orientation = 'vertical',
      'data-testid': testId = `GDS-${DISPLAY_NAME}`,
      ...props
    },
    ref,
  ) => {
    const responsiveOrientation =
      useResponsiveProp<GDSOrientationValues>(orientation);

    return responsiveOrientation === 'horizontal' ? (
      <GenesisCoreInspector displayName={`Horizontal ${DISPLAY_NAME}`}>
        <HorizontalStackLayout
          ref={ref}
          data-testid={testId}
          {...(props as GDSHorizontalStackLayoutProps)}
        />
      </GenesisCoreInspector>
    ) : (
      <GenesisCoreInspector displayName={`Vertical ${DISPLAY_NAME}`}>
        <VerticalStackLayout
          ref={ref}
          data-testid={testId}
          {...(props as GDSVerticalStackLayoutProps)}
        />
      </GenesisCoreInspector>
    );
  },
);

StackLayout.displayName = DISPLAY_NAME;
